import type { SelectionPromptSuggestion, SuggestionProvider } from "@/components/suggestions/types";
import type { EditorState } from "@tiptap/pm/state";

function selectionIsInsideDocumentTitle(state: EditorState): boolean {
  const title = state.doc.firstChild;

  if (title?.type.name !== "documentTitle") {
    return false;
  }

  return state.selection.to <= title.nodeSize;
}

export const selectionPromptSuggestionsProvider: SuggestionProvider<"selectionPrompt"> = {
  type: "selectionPrompt",
  search: (_str, doc) => {
    const { tiptap } = doc.editor;
    if (!tiptap || !doc.selection.hasActionableSelection) {
      return [];
    }

    if (selectionIsInsideDocumentTitle(tiptap.state)) {
      return [];
    }

    const suggestion: SelectionPromptSuggestion = {
      type: "selectionPrompt",
      trackingId: "ask_ai",
      icon: "AiHelper",
      priority: 0,
      popupGroup: "selectionPrompt",
    };

    return [[suggestion]];
  },
};
